import _ from 'lodash'
import moment from 'moment'

import TranslateService from '@/services/TranslateService'

export default {
  methods: {
    getEventDateText (event) {
      if (TranslateService.currentLocale === 'en') {
        const fromDateText = moment(event.dateFrom).format('D MMMM YYYY (ddd)')
        const toDateText = moment(event.dateTo).format('D MMMM YYYY (ddd)')
        return _.uniq(_.compact([fromDateText, toDateText])).join(' - ')
      } else {
        return _.uniq([
          [
            moment(event.dateFrom).format('YYYY'),
            this.$filters.translate('T_YEAR'),
            moment(event.dateFrom).format('M'),
            this.$filters.translate('T_MONTH'),
            moment(event.dateFrom).format('D'),
            this.$filters.translate('T_DAY'),
            ` (${this.$filters.translate(`T_WEEK_DAY_${moment(event.dateFrom).weekday()}`)})`
          ].join(''),
          [
            moment(event.dateTo).format('YYYY'),
            this.$filters.translate('T_YEAR'),
            moment(event.dateTo).format('M'),
            this.$filters.translate('T_MONTH'),
            moment(event.dateTo).format('D'),
            this.$filters.translate('T_DAY'),
            ` (${this.$filters.translate(`T_WEEK_DAY_${moment(event.dateTo).weekday()}`)})`
          ].join('')
        ]).join(' - ')
      }
    },
    getGroupBySearchDateText (event) {
      if (TranslateService.currentLocale === 'en') {
        const fromDateText = moment(event.dateFrom).format('YYYY MMM D')
        const toDateText = moment(event.dateTo).format('YYYY MMM D')
        return _.uniq(_.compact([fromDateText, toDateText])).join(' - ')
      } else {
        return _.uniq([
          [
            moment(event.dateFrom).format('YYYY'),
            this.$filters.translate('T_YEAR'),
            moment(event.dateFrom).format('M'),
            this.$filters.translate('T_MONTH'),
            moment(event.dateFrom).format('D'),
            this.$filters.translate('T_DAY')
          ].join(''),
          [
            moment(event.dateTo).format('YYYY'),
            this.$filters.translate('T_YEAR'),
            moment(event.dateTo).format('M'),
            this.$filters.translate('T_MONTH'),
            moment(event.dateTo).format('D'),
            this.$filters.translate('T_DAY')
          ].join('')
        ]).join(' - ')
      }
    },
    getDateText (date) {
      if (TranslateService.currentLocale === 'en') {
        moment(date).format('D MMM')
        return moment(date).format('D MMM')
      } else {
        return [
          moment(date).format('M'),
          this.$filters.translate('T_MONTH'),
          moment(date).format('D'),
          this.$filters.translate('T_DAY')
        ].join('')
      }
    }
  }
}
